import React from "react";

import { Link } from "react-router-dom";

import { PageHeader, Table, Typography, Popconfirm, Space, Button, Divider } from "antd";
import { displayDate } from "../../../../../core/utils/date";
import OnlyAdmin from "../../../../../core/components/auth/onlyAdmin";
import { DownloadOutlined, DeleteOutlined } from "@ant-design/icons";

import { LAYOUT_FINANCE_PAYMENT_SHOW } from "../../../navigation";

const { Text, Title } = Typography;

const Tasks = (props) => {
    const columns = (props) => [
        {
            title: "ID",
            dataIndex: "display_id",
            key: "display_id",
            width: 120,
            //render: (display_id, record) => <Link to={LAYOUT_FINANCE_PAYMENT_SHOW(record.id)}>{display_id}</Link>,
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date) => (date ? displayDate(date) : "-"),
            width: 120,
        },
        {
            title: "Notes",
            dataIndex: "notes",
            key: "notes",
        },
        {
            title: "Amount",
            dataIndex: "amount_value",
            key: "amount_value",
            align: "right",
            width: 200,
            render: (price, record) => (
                <>
                    {price} {record.amount_type}
                </>
            ),
        },
        {
            title: "Action",
            key: "operation",
            align: "center",
            width: 100,
            render: (record) => {
                return (
                    <Space>
                        {record.attachment && record.attachment?.name && (
                            <Button
                                style={{ margin: 0 }}
                                icon={<DownloadOutlined />}
                                size="small"
                                onClick={() => props.onDownloadReceipt(record.id, record.attachment?.name)}
                                disabled={props.actionLoading}
                            />
                        )}
                        <OnlyAdmin>
                            <Popconfirm
                                title="Are you sure?"
                                onConfirm={() => props.onDeletePayment(record.id)}
                                okText="Yes"
                                cancelText="No"
                                disabled={props.actionLoading}
                            >
                                <Button
                                    style={{ margin: 0 }}
                                    icon={<DeleteOutlined />}
                                    size="small"
                                    disabled={props.actionLoading}
                                    danger
                                />
                            </Popconfirm>
                        </OnlyAdmin>
                    </Space>
                );
            },
        },
    ];

    const payments = props.payments;

    if ((payments || []).length == 0) {
        return null;
    }

    const rowKey = (record) => record.id;

    return (
        <PageHeader ghost={false} title="Payments">
            <Table
                size="small"
                className="components-table-demo-nested"
                columns={columns(props)}
                rowKey={rowKey}
                dataSource={payments}
                pagination={false}
                bordered={true}
            />
        </PageHeader>
    );
};

export default Tasks;
